import { createContext, useContext } from "react";

// The actual userData/setUserData state still lives in useAppLogic (it owns
// the Firestore sync). This context just makes that pair available to any
// component in the tree without threading it through every intermediate
// component (Home.jsx, Events.jsx, etc. used to receive and forward it
// without using it themselves).
const UserContext = createContext(null);

export function UserProvider({ userData, setUserData, children }) {
  return (
    <UserContext.Provider value={{ userData, setUserData }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
}
